const footer = document.querySelector('.footer');

if (footer) {
    const cta = footer.querySelector('.footer__cta');

    if (cta) {
        let target = footer.previousElementSibling;

        if (target && target.lastElementChild) {
            target = target.lastElementChild;
        }

        let bgColor = null;

        while (target && target !== document.documentElement) {
            const bg = getComputedStyle(target).backgroundColor;

            if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
                bgColor = bg;
                break;
            }

            target = target.parentElement;
        }

        cta.style.setProperty('--footer-cta-top-color', bgColor || 'rgb(255, 255, 255)');
    }
}
